import React, { useEffect, useState } from "react";
import "../../Css/account.css";
import SignUpImg from "../../Images/Login/SignUp.gif";
import { LuUserRound } from "react-icons/lu";
import { Breadcrumb, Button, Checkbox, Form, Input, message, Upload } from "antd";
import { MdOutlineEmail } from "react-icons/md";
import { BsTelephone } from "react-icons/bs";
import { BiLockOpen } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUserToken } from "../../features/authSlice";
import { setProfile, storeToken } from "../../services/localStorageServices";
import { IoEyeOutline } from "react-icons/io5";
import { FaRegEyeSlash } from "react-icons/fa6";
import { post } from "../../services/userAuthAPI";
import demo_profile from "../../Images/demo_profile.jpg";
import { HiOutlinePlus } from "react-icons/hi";
import axios from "axios";
export default function SignUp() {
  const { token } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, [token, navigate]);

  const onFinish = async (values) => {
    setLoading(true);
  
    try {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("username", values.name);
      formData.append("phone", values.phone);
      formData.append("email", values.email);
      formData.append("password", values.password);
      formData.append("user_type","user")
  
      // If image selected, use it, otherwise fallback to demo image
      if (imageFile) {
        formData.append("profile_picture", imageFile);
      } else {
        const response = await fetch(demo_profile);
        const blob = await response.blob();
        const demoFile = new File([blob], "demo.jpg", { type: blob.type });
        formData.append("profile_picture", demoFile);
      }
  
      // Generate and append 10-digit token
      const token = Math.floor(1000000000 + Math.random() * 9000000000);
      formData.append("token", token.toString());
  
      // Static OTP (replace with actual logic if needed)
      formData.append("otp", "1234");
  
      const response = await axios.post("https://api.woodsy.co.in/api/users", formData);
      console.log("response", response);
  
      if (response?.data.token) {
        dispatch(setUserToken({ token: response?.data.token }));
        storeToken(response?.data.token);
        setProfile(response?.data.user);
        navigate("/");
      } else {
        console.error("Signup Error - Invalid response data:", response.data);
        message.error("Signup failed. Invalid response from server.");
      }
    } catch (error) {
      console.error("Signup Error", error);
      console.log("Full error response:", error?.response);
    
      const errorData = error?.response?.data?.errors;
      if (errorData && typeof errorData === "object") {
        const errorMessages = Object.values(errorData).flat().join(", ");
        message.error(errorMessages);
      } else {
        // Try showing fallback error message from server if available
        const fallbackMessage =
          error?.response?.data?.message ||
          error?.message ||
          "An error occurred during signup";
        message.error(fallbackMessage);
      }
    } finally {
      setLoading(false);
    }
  };
  


  const clientId = "413735203093-tt019nmdfqqkff5vf69lhskudqtph6m0.apps.googleusercontent.com";



  return (
    <>
      <div className="Register-main-con">
        <div className="row">
          <div className="col-md-6 px-5 d-flex align-items-center">
            <div className="account-card signUp">
              <div className="title">
                <h1>Sign Up</h1>
                <Breadcrumb
                  items={[
                    {
                      title: <Link to="/">Home</Link>,
                    },
                    {
                      title: "Sign Up",
                    },
                  ]}
                />
              </div>
              <div className="account-form">
                <Form
                  name="normal_login"
                  className="login-form"
                  layout="vertical"
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                >
                  <div className="row">
                    <div className="col-12">
                      <Form.Item label="Profile Picture">
                        <Upload
                          listType="picture-card"
                          maxCount={1}
                          accept="image/*"
                          beforeUpload={(file) => {
                            setImageFile(file);
                            return false; // Prevent automatic upload
                          }}
                          onRemove={() => setImageFile(null)}
                        >
                          {imageFile ? null : (
                            <div>
                              <HiOutlinePlus />
                              <div style={{ marginTop: 8 }}>Upload</div>
                            </div>
                          )}
                        </Upload>
                      </Form.Item>
                    </div>


                    <div className="col-12">
                      <Form.Item
                        name="name"
                        label="Name"
                        rules={[
                          {
                            required: true,
                            message: "Please input your name!",
                          },
                        ]}
                      >
                        <Input
                          prefix={<LuUserRound className="site-form-item-icon" />}
                          placeholder="Full Name"
                        />
                      </Form.Item>
                    </div>
                    <div className="col-md-6">
                      <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                          {
                            required: true,
                            message: "Please input your email!",
                          },
                          {
                            type: "email",
                            message: "Please enter a valid email!",
                          },
                        ]}
                      >
                        <Input
                          prefix={<MdOutlineEmail className="site-form-item-icon" />}
                          placeholder="Email"
                        />
                      </Form.Item>
                    </div>
                    <div className="col-md-6">
                      <Form.Item
                        name="phone"
                        label="Phone"
                        rules={[
                          {
                            required: true,
                            message: "Please input your phone no.!",
                          },
                          {
                            len: 10,
                            message: "Please enter a valid Phone!",
                          },
                        ]}
                      >
                        <Input
                          prefix={<BsTelephone className="site-form-item-icon" />}
                          placeholder="Phone No."
                        />
                      </Form.Item>
                    </div>
                    <div className="col-md-6">
                      <Form.Item
                        label="Password"
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "Please input your password!",
                          },
                        ]}
                      >
                        <Input.Password
                          prefix={<BiLockOpen className="site-form-item-icon" />}
                          placeholder="Password"
                          iconRender={visible => (visible ? <IoEyeOutline /> : <FaRegEyeSlash />)}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-md-6">
                      <Form.Item
                        label="Confirm Password"
                        name="password2"
                        dependencies={["password"]}
                        rules={[
                          {
                            required: true,
                            message: "Please confirm your password!",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || getFieldValue("password") === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error("The passwords do not match!"));
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          prefix={<BiLockOpen className="site-form-item-icon" />}
                          placeholder="Confirm Password"
                        />
                      </Form.Item>
                    </div>
                    <Form.Item>
                      <Form.Item name="remember" valuePropName="checked" noStyle>
                        <Checkbox>Remember me</Checkbox>
                      </Form.Item>
                    </Form.Item>

                    <Form.Item>
                      <Button
                        htmlType="submit"
                        className="login-form-button"
                        loading={loading}
                      >
                        {loading ? "Signing up..." : "Sign Up"}
                      </Button>
                      <br />
                      Or <Link to="/account/sign-in">login now!</Link>
                    </Form.Item>

                    {/* <Form.Item>
                      <div className="Google-Login-btn-con">
                        <GoogleLogin
                          clientId={clientId}
                          buttonText="Sign in with Google"
                          onSuccess={onSuccess}
                          onFailure={onFailure}
                          cookiePolicy={'single_host_origin'}
                          isSignedIn={true}
                        />
                      </div>
                    </Form.Item> */}

                  </div>
                </Form>
              </div>
            </div>
          </div>
          <div className="col-md-6 d-flex align-items-center">
            <img className="widthimage" src={SignUpImg} alt="Sign Up" />
          </div>
        </div>
      </div>
    </>
  );
}
